let container: HTMLDivElement | null = null

function getContainer() {
  if (!container) {
    container = document.createElement('div')
    container.style.cssText = `
      position: fixed; top: 32px; left: 50%; transform: translateX(-50%);
      z-index: 9999; display: flex; flex-direction: column; align-items: center; gap: 10px;
      pointer-events: none;
    `
    document.body.appendChild(container)
  }
  return container
}

export function showToast(message: string, duration = 2500) {
  const el = document.createElement('div')
  el.textContent = message
  el.style.cssText = `
    padding: 10px 20px;
    background: rgba(50, 53, 58, 0.88);
    color: #FFFFFF;
    font-size: 14px;
    border-radius: 8px;
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.2s;
    pointer-events: none;
  `
  getContainer().appendChild(el)
  requestAnimationFrame(() => {
    el.style.opacity = '1'
  })
  setTimeout(() => {
    el.style.opacity = '0'
    setTimeout(() => el.remove(), 220)
  }, duration)
}
